import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
import { ProjectsVendorsPage } from './pages/ProjectsVendorsPage';
import { ContactPage } from './pages/ContactPage';
import './index.css';
export function App() {
  return <Router data-id="element-0">
      <div className="min-h-screen bg-white font-sans flex flex-col" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-grow pt-20 md:pt-24 lg:pt-28" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/services" element={<ServicesPage data-id="element-8" />} data-id="element-7" />
            <Route path="/projects-vendors" element={<ProjectsVendorsPage data-id="element-10" />} data-id="element-9" />
            <Route path="/contact" element={<ContactPage data-id="element-12" />} data-id="element-11" />
          </Routes>
        </main>
        <Footer data-id="element-13" />
      </div>
    </Router>;
}